'use client';

/** https://www.npmjs.com/package/@optimizely/react-sdk */
import {
  OptimizelyProvider as Optimizely,
  createInstance,
} from '@optimizely/react-sdk';
import { FC, PropsWithChildren } from 'react';
import { OPTIMIZELY_SDK_KEY } from 'src/envVariables';

export const OptimizelyProvider: FC<PropsWithChildren<{ datafile: any }>> = ({
  children,
  datafile,
}) => {
  const _dev = process.env.NODE_ENV === 'development';

  if (!OPTIMIZELY_SDK_KEY || !datafile || _dev) {
    return <>{children}</>;
  }

  const optimizely = createInstance({
    sdkKey: OPTIMIZELY_SDK_KEY,
    datafile,
  });

  if (!optimizely) {
    return <>{children}</>;
  }

  optimizely.setUser({
    /** @todo need to investigate this field,
     * it should be real user id
     * probably it should be saved in cookies  */
    id: 'default-user',
  });

  return (
    <Optimizely optimizely={optimizely} isServerSide>
      {children}
    </Optimizely>
  );
};
